import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgressScreenComponent } from './screen/progress-screen.component';
import {SharedModule} from '../../shared/shared.module';
import { WeightChartComponent } from './components/weight-chart/weight-chart.component';
import { HeightChartComponent } from './components/height-chart/height-chart.component';
import { RedLightFoodChartComponent } from './components/red-light-food-chart/red-light-food-chart.component';
import { PhysicalActivityChartComponent } from './components/physical-activity-chart/physical-activity-chart.component';
import { ScreenTimeChartComponent } from './components/screen-time-chart/screen-time-chart.component';
import { JournalingChartComponent } from './components/journaling-chart/journaling-chart.component';
import { BmiChartComponent } from './components/bmi-chart/bmi-chart.component';
import { ChartBaseComponent } from './components/base/chart-base/chart-base.component';
import {StoreModule} from '@ngrx/store';
import {EffectsModule} from '@ngrx/effects';
import {ProgressEffects} from './core/progress.effects';
import {reducer} from './core/progress.reducers';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatMenuModule} from '@angular/material/menu';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatTableModule} from '@angular/material/table';
import {MatRadioModule} from '@angular/material/radio';
import {FormsModule} from '@angular/forms';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {InfiniteScrollModule} from 'ngx-infinite-scroll';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatInputModule} from '@angular/material/input';



@NgModule({
  declarations: [
    ProgressScreenComponent,
    WeightChartComponent,
    HeightChartComponent,
    RedLightFoodChartComponent,
    PhysicalActivityChartComponent,
    ScreenTimeChartComponent,
    JournalingChartComponent,
    BmiChartComponent,
    ChartBaseComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    StoreModule.forFeature('ss-cord.progress', reducer),
    EffectsModule.forFeature(
      [ProgressEffects]
    ),
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatPaginatorModule,
    MatTableModule,
    MatRadioModule,
    FormsModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    InfiniteScrollModule,
    MatTooltipModule,
    MatInputModule
  ]
})
export class ProgressModule { }
